import { render, staticRenderFns } from "./UploadKeyVision.vue?vue&type=template&id=1494feb2&scoped=true&"
import script from "./UploadKeyVision.vue?vue&type=script&lang=js&"
export * from "./UploadKeyVision.vue?vue&type=script&lang=js&"
import style0 from "./UploadKeyVision.vue?vue&type=style&index=0&id=1494feb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1494feb2",
  null
  
)

export default component.exports